import React, { useContext } from 'react'

// Create a context for authentication
const AuthContext = React.createContext()

// AuthProvider component that provides the authentication context to its children
export function AuthProvider({ children, value }) {
  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

// Custom hook to access the authentication context value
export function useAuthValue() {
  return useContext(AuthContext)
}
